import React from 'react';
import styled from 'styled-components';
import Toolbar from '@mui/material/Toolbar';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { withTheme } from '@mui/styles';
import List from '@mui/material/List';

import { drawerWidth } from '../AppShell/theme';

export const Root = styled.div`
  display: flex;
`;

export const LogoToolbar = styled(Toolbar)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.main`
  flex-shrink: 1;
  flex-grow: 1;
  ${({ noMargin }) => !noMargin && `margin-left: ${drawerWidth}px;`}
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Logo = () => <img src="/images/logo.png" alt='Logo'/>;

export const DrawerListItem = withTheme(styled(ListItem).attrs({
  button: true,
})`
  &.active {
    span {
      color: white !important;
    }
  }
  &:hover, &:focus {
    background-color: #f8984e !important;
  }
  svg {
    color: ${({ theme }) => theme.custom.sideBarTextColor};
  }
`);

export const DrawerListItemText = withTheme(styled(ListItemText)`
  font-size: 14px;
  color: ${({ theme }) => theme.custom.sideBarTextColor};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`);

export const DrawerListItemIcon = ListItemIcon;

export const NestedList = withTheme(styled(List).attrs({
  disablePadding: true,
  component: 'div',
})`
  padding-left: ${({ theme }) => theme.spacing(2)}px !important;
`);